<div mat-dialog-title class="terms-and-condition-dialog-header">
  <img
    src="/icons/ic_close.svg"
    class="cancel-icon"
    alt="Close"
    mat-dialog-close
    width="22px"
    height="22px"
  />
</div>

<div mat-dialog-content class="terms-and-condition-content">
  <!-- Terms of Service Container -->
  <div class="terms-container">
    <h1 class="terms-title">Terms of Service</h1>

    <!-- 1. Agreement -->
    <div class="terms-section">
      <h2>1. Agreement</h2>
      <p>
        This Agreement is a rent agreement and the LESSEE shall not have or acquire any right,
        title, or interest in or to the Vehicle, except the right to use or operate it as provided
        herein. The Vehicle rented under this Agreement is totally owned by the LESSOR.
      </p>
      <p class="arabic">
        هذه االتفاقية هي اتفاقية إيجار وال يستحوذ المستأجر على أو يكون له أي حق أو ملكية أو مصلحة في
        المركبة، باستثناء الحق في استخدامها أو تشغيلها على النحو المنصوص عليه في هذه الوثيقة. وتكون
        السيارة المستأجرة بموجب هذه االتفاقية مملوكة بالكامل من قبل المؤجر
      </p>
    </div>

    <!-- 2. Vehicle Inspection -->
    <div class="terms-section">
      <h2>2. Vehicle Inspection</h2>
      <p>
        The LESSEE shall inspect the Vehicle before taking delivery of the Vehicle, and by taking
        delivery of the Vehicle the LESSEE acknowledges that the Vehicle is suitable for the purpose
        for which it is being rented.
      </p>
      <p class="arabic">
        يجب على المستأجر فحص المركبة قبل تسلمها. ويقر المستأجر من خالل استالمه للمركبة بأنها مناسبة
        للغرض الذي استأجرها من أجله
      </p>
    </div>

    <!-- 3. Driving License Requirement -->
    <div class="terms-section">
      <h2>3. Driving License Requirement</h2>
      <p>
        The LESSEE is required to have a valid driving license throughout the duration of the rent.
        A Qatari driving license is a must in case the LESSEE holds a Qatari ID. International
        driving license are valid as per the Qatari applicable laws and regulations in this respect.
      </p>
      <p class="arabic">
        كون المستأجر مطالب بحيازة رخصة قيادة سارية المفعول طوال مدة اإليجار. وال بد للمستأجر من
        حيازة رخصة القيادة القطرية في حال كان يحمل الرقم القطري. كما وتكون رخصة القيادة الدولية
        صالحة وفقا للقوانين واللوائح القطرية المعمول بها في هذا الصدد
      </p>
    </div>

    <!-- 4. Prohibited Uses -->
    <div class="terms-section">
      <h2>4. Prohibited Uses</h2>
      <p>
        During the duration of this Agreement and under no circumstances shall the Vehicle be used,
        operated or driven:
      </p>
      <ol class="subpoints" type="A">
        <li>
          <p>In case of invalid or withheld driving licenses of the end user for any reason</p>
          <p class="arabic">
            في حالة حيازة رخصة قيادة غير صالحة أو حجز رخصة القيادة الخاصة بالمستخدم النهائي ألي سبب
            من األسباب
          </p>
        </li>
        <li>
          <p>
            Under the Influence of Alcohol or Narcotics (Damages / Accidents arising from the same
            will be charged in full)
          </p>
          <p class="arabic">
            القيادة تحت تأثير الكحول أو المخدرات ( حيث سيتحمل المستأجر األضرار/ الحوادث الناجمة عن
            ذلك بالكامل)
          </p>
        </li>
        <li>
          <p>
            For the transportation of persons or property for remuneration or reward either
            expresses or implied
          </p>
          <p class="arabic">نقل األشخاص أو الممتلكات لقاء مكافأة سواء أكانت صريحة أو ضمنية</p>
        </li>
        <li>
          <p>By any person, in any race, speed test, contest or experiment</p>
          <p class="arabic">
            استخدامها من قبل أي شخص، في أي سباق أو اختبار سرعة أو مسابقة أو تجربة،
          </p>
        </li>
        <li>
          <p>
            To propel or tow any Vehicle or trailer - Outside the State of Qatar. By any person
            except the LESSEE or any other person authorized expressly by the LESSEE
          </p>
          <p class="arabic">
            دفع أو سحب أي سيارة أو مقطورة - خارج دولة قطر. استخدامها من قبل أي شخص عدا المستأجر أو
            أي شخص آخر مفوض من قبل المستأجر
          </p>
        </li>
        <li>
          <p>
            Without respecting any warranty or guarantee given by the manufacturer, agent or dealer
            of the Vehicle
          </p>
          <p class="arabic">
            دون احترام أي ضمان أو كفالة مقدمة من قبل الشركة المصنعة أو وكيل أو تاجر المركبة
          </p>
        </li>
        <li>
          <p>
            In violation or contravention of any enforceable Qatar Law, statute, ordinance,
            regulation or order.
          </p>
          <p class="arabic">انتهاك أو مخالفة أي قانون قطري نافذ أو مرسوم أو الئحة أو أمر</p>
        </li>
      </ol>
    </div>

    <!-- 5. Possession of Vehicle -->
    <div class="terms-section">
      <h2>5. Possession of Vehicle</h2>
      <p>The LESSEE may not part with possession of, or abandon the Vehicle.</p>
      <p class="arabic">ال يجوز للمستأجر االبتعاد عن المركبة أو التخلي عنها</p>
    </div>

    <!-- 6. Lessor Termination Right -->
    <div class="terms-section">
      <h2>6. Lessor Termination Right</h2>
      <p>
        The LESSOR has the right, at any time and without providing any reasons, to terminate this
        Agreement prior to its end date. In such case, the LESSEE shall immediately return back the
        Vehicle, and the LESSOR shall not be liable for any loss or damage sustained or may be
        sustained by the LESSEE as a result of such demand.
      </p>
      <p class="arabic">
        يحق للمؤجر، في أي وقت ودون إبداء أي أسباب، فسخ هذه االتفاقية قبل تاريخ انتهائها. وفي هذه
        الحالة، يجب على المستأجر اعادة المركبة. ولن يكون المؤجر مسؤوال عن أي خسارة أو ضرر قد يقع على
        المستأجر نتيجة لهذا الطلب
      </p>
    </div>

    <!-- 7. Property in Vehicle -->
    <div class="terms-section">
      <h2>7. Property in Vehicle</h2>
      <p>
        The LESSOR shall not be liable for any loss or damage to any property left, stored or
        transported by the LESSEE or any other person in the Vehicle either before or after the
        return of the Vehicle.
      </p>
      <p class="arabic">
        ل يتحمل المؤجر المسؤولة عن أي خسارة أو ضرر قد يقع على أي ممتلكات تم تركها في المركبة أو
        تخزينها أو نقلها من قبل المستأجر أو أي شخص آخر في المركبة سواء قبل أو بعد ارجاعها
      </p>
    </div>

    <!-- 8. Fines and Violations -->
    <div class="terms-section">
      <h2>8. Fines and Violations</h2>
      <p>
        The LESSEE is solely responsible and liable in full for penalties, fines, expenses and
        forfeitures imposed for violations of any governmental regulation or law, ordinance or a
        rule or regulation of an insurance policy. All traffic fines and violations that may occur
        when the Vehicle is under the possession of the LESSEE should be charged and the points
        applied (If any) to the LESSEE. All these penalties and expenses that the LESSOR pays on
        behalf of the LESSEE will be recovered from the latter.
      </p>
      <p class="arabic">
        كون المستأجر هو المسؤول الوحيد بالكامل عن العقوبات والغرامات والمصاريف المفروضة نتيجة
        النتهاك أي نظام حكومي أو قانون أو مرسوم أو قاعدة أو الئحة خاصة ببوليصة التأمين. ويدفع
        المستأجر جميع المخالفات واالنتهاكات المرورية التي قد تحدث أثناء حيازته للمركبة ويتم احتساب
        النقاط (إن وجدت) على المستأجر. كما وسيتم استرداد جميع هذه العقوبات والنفقات التي يدفعها
        المؤجر نيابة عن المستأجر من المستأجر
      </p>
    </div>

    <!-- 9. Indemnity -->
    <div class="terms-section">
      <h2>9. Indemnity</h2>
      <p>
        The LESSEE shall defend, indemnify and hold the LESSOR harmless from any and against all
        losses, damages, injuries, claims, demands, and expenses arising out of or in connection
        with the Vehicle during this Agreement or any renewal thereto.
      </p>
      <p class="arabic">
        يجب على المستأجر الدفاع عن المؤجر وتعويضه واعفاءه من أي وضد جميع الخسائر واألضرار واإلصابات
        والدعاوى والمطالبات والنفقات الناشئة عن المركبة أو المتعلقة فيها خالل فترة هذه االتفاقية أو
        أي فترة تجديد لها
      </p>
    </div>

    <!-- 10. Fuel and Daily Checkups -->
    <div class="terms-section">
      <h2>10. Fuel and Daily Checkups</h2>
      <p>
        The LESSEE shall be responsible for fuel and routine daily checkups for levels. The LESSEE
        shall be liable for all cost of repairs resulting from failure to do so and the misuse of
        the Vehicle.
      </p>
      <p class="arabic">
        يجب على المستأجر أن يكون مسؤوال عن الوقود وعن الفحوصات الروتينية اليومية لمستوياته. كما ويجب
        على المستأجر أن يكون مسؤوال عن جميع تكاليف اإلصالحات الناجمة عن عدم قيامه بتلك الفحوصات عن
        وسوء استخدامه للمركبة
      </p>
    </div>

    <!-- 11. Service Sticker -->
    <div class="terms-section">
      <h2>11. Service Sticker</h2>
      <p>
        All vehicles are equipped with a labeled Sticker that shows the next periodic service
        interval. Failure to return the Vehicle for periodic maintenance at due time would be
        chargeable.
      </p>
      <p class="arabic">
        لقد تم وضع ملصق على جميع المركبات والذي يظهر فترة الخدمة الدورية المقبلة. وسيتم فرض رسوم في
        حالة عدم ارجاع المركبة في الوقت المناسب من أجل الصيانة الدورية
      </p>
    </div>

    <!-- 12. Maintenance Responsibility -->
    <div class="terms-section">
      <h2>12. Maintenance Responsibility</h2>
      <p>
        The LESSOR shall carry out at its own cost all maintenance works including periodical
        services. Any repair that is required due to the misuse / negligence of the LESSEE will be
        charged to the LESSEE.
      </p>
      <p class="arabic">
        يجب على المؤجر القيام جميع أعمال الصيانة بما في ذلك الخدمات الدورية على نفقته الخاصة.
        وسيتحمل المستأجر تكاليف أي إصالح يطلب بسبب سوء االستخدام أو اإلهمال من قبل المستأجر
      </p>
    </div>

    <!-- 13. Alterations -->
    <div class="terms-section">
      <h2>13. Alterations</h2>
      <p>The LESSEE should not make any alterations to the Vehicle.</p>
      <p class="arabic">ال يجب على المستأجر القيام بأي تعديالت على المركبة</p>
    </div>

    <!-- 14. Repairs by Lessee -->
    <div class="terms-section">
      <h2>14. Repairs by Lessee</h2>
      <p>
        The LESSEE is requested not to perform, allow or permit any kind of repairs to the Vehicle
        and in case the repair(s) do not meet the LESSOR’s standards, it would be replaced by the
        LESSOR and the complete cost for new parts and garages would be chargeable to the LESSEE.
      </p>
      <p class="arabic">
        يطلب من المستأجر عدم القيام بأي نوع من اإلصالحات على المركبة أو السماح بها. وفي حال عدم
        ايفاء اإلصالح (اإلصالحات) بمعايير المؤجر، سيتم استبدالها من قبل المؤجر وسيتحمل المستأجر
        التكلفة الكاملة عن القطع جديدة باإلضافة إلى تكلفة المرائب
      </p>
    </div>

    <!-- 15. Replacement Vehicle -->
    <div class="terms-section">
      <h2>15. Replacement Vehicle</h2>
      <p>
        A replacement vehicle of the same category will be provided to the LESSEE when the rented
        Vehicle requires a long service duration, or in case of breakdown or accident repair. In
        such case, the same Terms and Conditions of this Agreement should be applicable.
      </p>
      <p class="arabic">
        سيتم توفير سيارة بديلة من نفس الفئة للمستأجر عندما تتطلب السيارة المستأجرة مدة خدمة طويلة أو
        في حالة العطل أو اصالح الحوادث. وفي هذه الحالة، يجب أن يتم تطبيق نفس شروط وأحكام هذه
        االتفاقية
      </p>
    </div>

    <!-- 16. Misuse Charges -->
    <div class="terms-section">
      <h2>16. Misuse Charges</h2>
      <p>
        All the costs and expenses related to the misuse of the Vehicle originated by repairs for
        the following instances will be charged to the LESSEE based on the garages actual cost (in
        case the insurance cannot be claimed); may be defined (but not limited to) as instances of
        Misuse:
      </p>
      <ol class="subpoints" type="A">
        <li>
          <p>
            Paint damages / Sand blast / Tyre Breakage / Seat Stains / Cigarette Burns / damage to
            the integral parts of the vehicle.
          </p>
          <p class="arabic">
            أضرار على الطالء / التنظيف بالرمل / تلف إطار العجلة / بقع على المقعد / حروق بسبب
            السجائر/ ضرر في األجزاء المكملة للمركبة،
          </p>
        </li>
        <li>
          <p>Off-Road driving (Sand Dunes, Rocky Deserts, Sea Water and Sea Beaches etc).</p>
          <p class="arabic">
            القيادة على الطرق الوعرة (الكثبان الرملية، الصحارى الصخرية، مياه البحر وشواطئ البحر وما
            إلى ذلك)،
          </p>
        </li>
        <li>
          <p>Smoking in the car is prohibited and chargeable at QAR. 500.</p>
          <p class="arabic">التدخين في السيارة ممنوع ويفرض عليه غرامة بقيمة 500 لاير قطري،</p>
        </li>
        <li>
          <p>
            Driving inside high level waters causing water absorption into the engine, destroying
            pistons and connecting rods.
          </p>
          <p class="arabic">
            القيادة داخل مستوى مرتفع من المياه والذي يؤدي إلى امتصاص المحرك للماء وتدمير المكابس
            وأذرع التوصيل،
          </p>
        </li>
        <li>
          <p>Skipping the service interval of 10,000 KM. Chargeable based on garage report.</p>
          <p class="arabic">
            سيتم فرض رسوم على تخطي فترة الخدمة بـ 10000 كم وسيتم حسابها استنادا إلى تقرير المرآب.
          </p>
        </li>
        <li>
          <p>Pulling / towing other vehicle or trailers.</p>
          <p class="arabic">سحب / قطر مركبات أو مقطورات أخرى</p>
        </li>
      </ol>
    </div>

    <!-- 17. Inspection/Registration Delay -->
    <div class="terms-section">
      <h2>17. Inspection/Registration Delay</h2>
      <p>
        In case, the LESSEE does not return the Vehicle on the agreed time for technical inspection
        or registration Renewal, the LESSEE is liable to pay QAR 500 for each
        inspection/registration renewal.
      </p>
      <p class="arabic">
        يكون المستأجر مسؤوال عن دفع 500 لاير قطري عن كل التفتيش / تجديد للتسجيل في حالة عدم قيامه
        بإعادة المركبة في الوقت المتفق عليه للفحص الفني أو لتجديد التسجيل
      </p>
    </div>

    <!-- 18. Accidents Procedure -->
    <div class="terms-section">
      <h2>18. Accidents Procedure</h2>
      <ol class="subpoints" type="A">
        <li>
          <p>
            In the event of an accident, the LESSEE must not move the Vehicle from the scene of the
            accident before the arrival of the Police to make a report of the accident, unless
            advised by the authorities.
          </p>
          <p class="arabic">
            في حالة وقوع حادث، يجب على المستأجر عدم تحريك سيارة من مكان الحادث قبل وصول الشرطة
            لتقديم تقرير عن الحادث إال إذا نصحت السلطات بذلك.
          </p>
        </li>
        <li>
          <p>
            The LESSEE hereby undertakes to immediately inform the LESSOR of any accident which
            occurs during the rental period to officials and attending the police station (if
            required).
          </p>
          <p class="arabic">
            يتعهد المستأجر بموجب هذه االتفاقية بإبالغ المؤجر على الفور بوقوع أي حادث خالل فترة
            اإليجار إلى المسؤولين والحضور إلى مركز الشرطة )إذا لزم األمر
          </p>
        </li>
        <li>
          <p>
            The LESSEE shall also be required to provide all necessary assistance to the LESSOR in
            completing the insurance claim request to the insurance provider and to deliver to the
            LESSOR the police report and the repair order. The LESSEE shall pay to the LESSOR all
            rental charges herein, until such time the police reports are delivered or shall notify
            the LESSOR in writing and obtain acknowledgment for such writing from LESSOR if no
            police report is available.
          </p>
          <p class="arabic">
            يكون المستأجر مطالبا بتقديم كافة المساعدات الالزمة للمؤجر في استكمال طلب التعويض من شركة
            التأمين وتسليم تقرير الشرطة وأمر اإلصالح إلى المؤجر. ويجب على المستأجر دفع جميع رسوم
            اإليجار المنصوص عليها هنا إلى المؤجر، إلى أن يحين وقت تسليم تقارير الشرطة أو إخطار
            المؤجر كتابة والحصول على إقرار بهذا اإلخطار من المؤجر إذا لم يكن تقرير الشرطة متاحا
          </p>
        </li>
        <li>
          <p>
            Replacement Vehicle in case of damage will be provided only if the LESSEE submits the
            required police reports.
          </p>
          <p class="arabic">
            وسيتم توفير مركبة بديلة في حالة وقوع ضرر وذلك إذا قام المستأجر بتقديم تقارير الشرطة
            المطلوبة
          </p>
        </li>
        <li>
          <p>
            In the event that any costs incurred in repairing the damages to the Vehicle are not
            recovered from the insurance provider or manufacturer by warranty, the LESSEE shall be
            liable to bear such costs paid by LESSOR to reinstate the Vehicle to its original state.
            The LESSEE shall also be required to pay any deductibles that may be payable by the
            LESSOR.
          </p>
          <p class="arabic">
            في حال عدم التمكن من استرداد أي تكاليف متكبدة من إصالح األضرار التي لحقت بالسيارة من
            شركة التأمين أو من الشركة المصنعة بواسطة الكفالة، يجب على المستأجر تحمل مثل هذه التكاليف
            التي دفعها المؤجر إلعادة المركبة إلى حالتها األصلية. ويكون المستأجر مطالبا أيضا بدفع أي
            خصومات قد تكون مستحقة الدفع من قبل المؤجر
          </p>
        </li>
        <li>
          <p>
            The LESSEE is liable to pay for the excess insurance charges / claims for each accident
            in which the Vehicle may be involved.
          </p>
          <p class="arabic">
            يكون المستأجر مسؤوال عن دفع رسوم/ مطالبات التأمين الزائدة عن كل حادث قد تكون المركبة
            متورطة فيه.
          </p>
        </li>
        <li>
          <p>
            In the event that the Vehicle is lost or stolen or destroyed and/or damaged beyond
            economic repair, any loss incurred by the LESSOR as a result of such events and not
            recovered from the insurance providers for the said Vehicle, for any reason, shall be
            paid by the LESSEE to the LESSOR.
          </p>
          <p class="arabic">
            يجب أن يقوم المستأجر بدفع تكاليف أي خسارة يتكبدها المؤجر كنتيجة لفقدان أو سرقة أو تدمير
            و/أو تلف المركبة يتعدى اإلصالح االقتصادي ولم يتم استرداده من شركة التأمين على المركبة
            المذكورة ألي سبب كان
          </p>
        </li>
        <li>
          <p>
            In the instance of Total Loss or cancellation (vehicle rendered unfit for usage), the
            LESSEE is liable to pay for insurance claims. In case the Insurance Company declines the
            claim for any damages or accidents or total loss, the LESSEE would be liable to pay for
            the charges in full.
          </p>
          <p class="arabic">
            في حالة الخسارة الكلية أو اإللغاء )تصبح المركبة غير صالحة لالستخدام(، يكون المستأجر
            مسؤوال عن لدفع مطالبات التأمين. يكون المستأجر مسؤوال عن دفع الرسوم بالكامل في حال امتنعت
            شركة التأمين عن التعويض عن أي أضرار أو حوادث أو فقدان تام للمركبة.
          </p>
        </li>
        <li>
          <p>
            The LESSEE may be liable to pay the rental charges for the period for which the Vehicle
            is in for repairs related to accidents. Additionally, the LESSEE may also be liable to
            pay rental charges for the replacement which will be considered as continuation of the
            original agreement.
          </p>
          <p class="arabic">
            قد يكون المستأجر مسؤوال عن دفع رسوم اإليجار عن الفترة التي تكون فيها المركبة في التصليح
            بسبب الحوادث. وباإلضافة إلى ذلك، قد يكون المستأجر أيضا مسؤوال عن دفع رسوم اإليجار
            الستبدال المركبة والذي سيتم اعتباره على أنه استمرار لالتفاقية األصلية.
          </p>
        </li>
      </ol>
    </div>

    <!-- 19. Premature Termination Fee -->
    <div class="terms-section">
      <h2>19. Premature Termination Fee</h2>
      <p>
        In case of premature termination of this Agreement prior to its end date, the LESSEE is
        liable to pay a percentage that should be solely determined by the LESSOR as cancellation
        fee for the remaining rental charges.
      </p>
      <p class="arabic">
        في حالة الفسخ المبكر لهذه االتفاقية قبل موعد نهايتها، يكون المستأجر مسؤوال عن دفع نسبة
        يحددها المؤجر بمفرده كرسوم إلغاء لرسوم اإليجار المتبقية.
      </p>
    </div>

    <!-- 20. Short-Term Premature Termination -->
    <div class="terms-section">
      <h2>20. Short-Term Premature Termination</h2>
      <p>
        In case of premature termination of short term rental contracts, such as weekly and monthly
        rentals, the forerunning hire rate would be applicable. (Ex: Monthly rental’s closed
        prematurely, would be charged at the weekly rate. Weekly rental’s closed prematurely, would
        be charged at the daily hire rate).
      </p>
      <p class="arabic">
        في حالة الفسخ المبكر لعقود اإليجار القصيرة األجل مثل االيجارات األسبوعية والشهرية، يتم تطبيق
        قيمة التأجير السابق. )مثال: يتم دفع اإليجار الشهري الملغى قبل أوانه بقيمة التأجير األسبوعي
        ويتم دفع اإليجار األسبوعي الملغى قبل أوانه بقيمة التأجير اليومي(
      </p>
    </div>

    <!-- 21. Rent Rates -->
    <div class="terms-section">
      <h2>21. Rent Rates</h2>
      <p>The Rent Rates should be paid by the LESSEE as mentioned in the Particulars Section.</p>
      <p class="arabic">يجب على المستأجر دفع أسعار اإليجار على النحو المذكور في قسم التفاصيل</p>
    </div>

    <!-- 22. Payment Terms -->
    <div class="terms-section">
      <h2>22. Payment Terms</h2>
      <p>
        The LESSEE agrees to pay the rent rates without deduction, setoff, or counter claim. If the
        delivery date is other than the first or the last day of the month, the monthly rate shall
        be prorated for that month.
      </p>
      <p class="arabic">
        يوافق المستأجر على دفع قيمة اإليجار دون خصم أو تعويض أو دعوى مضادة. وإذا كان تاريخ التسليم
        في يوم غير آخر يوم أو أول يوم من الشهر، يتم تحديد استحقاقات المعدل الشهري بالتناسب لهذا
        الشهر.
      </p>
    </div>

    <!-- 23. Authorization of Payments -->
    <div class="terms-section">
      <h2>23. Authorization of Payments</h2>
      <p>
        The LESSEE authorizes the LESSOR to present any payments/guarantees made by the LESSEE
        (through credit cards/cheques/BNPL solutions) and use their proceeds to pay any amounts due
        under the Agreement.
      </p>
      <p class="arabic">
        يقوم المستأجر بتفويض المؤجر بتقديم أي مدفوعات/ ضمانات قام المستأجر بتقديمها )عن طريق بطاقات
        االئتمان / الشيكات / حلول االئتمان المتأخر الدفع( واستخدام عائداتها في دفع أي مبالغ مستحقة
        بموجب االتفاقية.
      </p>
    </div>

    <!-- 24. Partial Payments -->
    <div class="terms-section">
      <h2>24. Partial Payments</h2>
      <p>
        The LESSOR's acceptance of any partial payment of any Rental(s) which are due does not
        constitute a waiver of any of its rights to full payment.
      </p>
      <p class="arabic">
        ال بعتبر قبول المؤجر أية مدفوعات جزئية مستحقة من أي تأجير تنازال عن أي حق من حقوقه بالدفع
        الكامل
      </p>
    </div>

    <!-- 25. Late Return -->
    <div class="terms-section">
      <h2>25. Late Return</h2>
      <p>
        If the LESSEE returns the Vehicle four (4) hours after the original deadline to return the
        Vehicle, it would be charged as a full day’s rental.
      </p>
      <p class="arabic">
        يجب على المستأجر دفع أجرة يوم كامل إذا قام بإرجاع المركبة بعد أربعة )4 )ساعات من الموعد
        النهائي األصلي المحدد إلرجاع المركبة
      </p>
    </div>

    <!-- 27. Insurance -->
    <div class="terms-section">
      <h2>27. Insurance</h2>
      <ol class="subpoints" type="A">
        <li>
          <p>
            Personal accident covers are subject to the terms and conditions of the Insurance
            Policy.
          </p>
          <p class="arabic">تخضع تغطية الحوادث الشخصية لشروط وأحكام وثيقة التأمين</p>
        </li>
        <li>
          <p>
            All vehicles and passengers are provided with Comprehensive Insurance which includes
            Driver and passenger insurance. The LESSOR agrees to procure and keep in force during
            the period of the rental a valid insurance policy for the Vehicle and passengers.
          </p>
          <p class="arabic">
            تكون جميع المركبات مؤمنة تأمينا شامال بحيث يشمل هذا التأمين السائق والركاب. يوافق المؤجر
            على شراء بوليصة تأمين صالحة على المركبة والركاب واإلبقاء على سريانها خالل فترة االستئجار
          </p>
        </li>
        <li>
          <p>
            Such insurance will cover liability to all third parties, including passengers
            travelling in the Vehicle and the driver and the proceeds payable by the insurance
            company will be in accordance with the directives of the government of Qatar, the
            ministry of interior, the traffic department in force at the time of any accident giving
            rise to a claim.
          </p>
          <p class="arabic">
            سيغطي هذا التأمين مسؤولية جميع األطراف الثالثة، بما في ذلك المسافرين في المركبة والسائق،
            وستكون العائدات التي تدفعها شركة التأمين وفقا لتوجيهات الحكومة القطرية ووزارة الداخلية
            وإدارة المرور النافذة وقت وقوع أي حادث أدى إلى المطالبة.
          </p>
        </li>
        <li>
          <p>
            The LESSEE, their agents or employees shall comply with the terms and conditions of the
            said insurance policy, including the immediate reporting of all thefts and accidents to
            the LESSOR, accompanied by a police accident report, and to do all things necessary or
            proper to protect and preserve the LESSOR’s rights as a named insured in said insurance
            policies.
          </p>
          <p class="arabic">
            يجب على المستأجر ووكالئه أو موظفيه اإللتزام بشروط وأحكام وثيقة التأمين، بما في ذلك إبالغ
            المؤجر بجميع السرقات والحوادث باإلضافة إلى تقديم تقرير الشرطة عن الحادث وفعل جميع
            األشياء الضرورية أو المناسبة لحماية وصون حقوق المؤجر باعتباره المؤمن في بوالص التأمين
            المذكورة.
          </p>
        </li>
        <li>
          <p>
            Insurance will not cover accidents on construction sites or sand/desert dunes, or caused
            by jumping on red light, driving opposite on a one way road, driving under influence of
            alcohol or narcotics, driving without a valid driving license, illegal towing.
          </p>
          <p class="arabic">
            ال يغطي التأمين الحوادث في مواقع البناء أو الكثبان الرملية / الصحراوية أو الحوادث
            الناجمة عن تخطي الضوء األحمر والقيادة عكس السير على طريق باتجاه واحد والقيادة تحت تأثير
            الكحول أو المخدرات والقيادة بدون رخصة قيادة سارية المفعول والقطر غير قانوني.
          </p>
        </li>
        <li>
          <p>
            The LESSEE is liable to pay for excess insurance charges (for accidents) or total Loss /
            cancellation (Vehicle rendered unfit for usage) charges if the LESSEE is at fault.
          </p>
          <p class="arabic">
            يكون المستأجر مسؤوال عن دفع رسوم التأمين الزائدة بسبب (الحوادث) أو رسوم الفقدان/اإللغاء
            الكلي للمركبة (تصبح المركبة غير صالحة لالستخدام) إذا كان ذلك خطأ المستأجر
          </p>
        </li>
        <li>
          <p>
            In case the Insurance Company declines the LESSOR’s claim for any damages or accidents
            or total loss, the LESSEE should be liable to pay for the total charges.
          </p>
          <p class="arabic">
            يكون المستأجر مسؤوال عن دفع التكاليف اإلجمالية في حال رفض شركة التأمين مطالبة المؤجر
            بالتعويض عن أي أضرار أو حوادث أو فقدان تام.
          </p>
        </li>
      </ol>
    </div>

    <!-- 28. Renewal -->
    <div class="terms-section">
      <h2>28. Renewal</h2>
      <p>
        If the LESSEE wishes to renew the rental period he should inform the LESSOR by giving the
        latter a prior 3 days’ notice in writing. This Agreement cannot be renewed for another
        period unless agreed in writing by the LESSOR. The Agreement will be renewed under the same
        terms and conditions provided for herein, unless the LESSOR decides to change the rental
        rates or any other condition.
      </p>
      <p class="arabic">
        يجب على المستأجر إذا رغب بتجديد فترة اإليجار ابالغ المؤجر عن طريق إشعار خطي قبل 3 أيام. وال
        يمكن تجديد هذه االتفاقية لفترة أخرى ما لم يوافق المؤجر خطيا على ذلك. ويمكن تجديد هذه
        االتفاقية بنفس األحكام والشروط المنصوص عليها هنا، ما لم يقرر المؤجر تغيير قيمة اإليجار أو أي
        شرط آخر
      </p>
    </div>

    <!-- 29. Breach and Immediate Termination -->
    <div class="terms-section">
      <h2>29. Breach and Immediate Termination</h2>
      <p>
        In the event where the LESSEE breaches any of its obligations under this Agreement, or in
        case of death, declaration of bankruptcy or liquidation of the LESSEE, the LESSOR has the
        right to terminate this Agreement immediately without the need to a court recourse or any
        other legal procedure, and the LESSEE shall in this event return the Vehicle immediately to
        the LESSOR. If the LESSEE failed to return the Vehicle within 5 days of receiving a notice
        in this regard, the LESSEE shall be considered as retaining the Vehicle illegally by force,
        and the LESSOR shall have the right to consider all means available to it by law to protect
        its interest, including reverting to legal actions.
      </p>
      <p class="arabic">
        في حالة مخالفة المستأجر أي من التزاماته بموجب هذه االتفاقية، أو في حالة وفاة المستأجر أو
        إعالن إفالسه أو التصفية، يحق للمؤجر إنهاء هذه االتفاقية على الفور دون الحاجة إلى اللجوء
        للمحكمة أو إلى أي إجراء قانوني آخر، ويلتزم المستأجر في هذه الحالة بإرجاع المركبة على الفور
        للمؤجر. إذا لم يقم المستأجر بإرجاع المركبة خالل 5 أيام من تلقي اإلشعار في هذا الصدد، يعتبر
        المستأجر على أنه يحتفظ بالمركبة بطريقة غير مشروعة وبالقوة، ويحق للمؤجر الحق باستخدام في جميع
        الوسائل المتاحة له بموجب القانون لحماية مصالحه، بما في ذلك اللجوء إلى اإلجراءات القانونية.
      </p>
    </div>

    <!-- 30. Governing Law and Jurisdiction -->
    <div class="terms-section">
      <h2>30. Governing Law and Jurisdiction</h2>
      <p>
        This Agreement shall be governed by the applicable laws in the State of Qatar, and the
        courts of Qatar shall be the competent courts to settle any conflict between the parties
        regarding the implementation and the execution of this Agreement.
      </p>
      <p class="arabic">
        تخضع هذه االتفاقية للقوانين المعمول بها في دولة قطر، وتكون المحاكم القطرية هي المحاكم
        المختصة بتسوية أي نزاع ينشأ بين الطرفين بشأن تنفيذ هذه االتفاقية
      </p>
    </div>
    <section class="w-100 d-flex justify-content-end mt-3">
      <button
        type="button"
        mat-raised-button
        class="btn-submit"
        style="width: 200px"
        (click)="onAgreed()"
      >
        {{ 'Agreed' | translate }}
      </button>
    </section>
  </div>
</div>
